import { reduce } from 'lodash';
import { getBasicConfig$Cache } from "@/common/service/common";
import {ON_SESSION_PAYMENT_SUPPORTED_FLOWS} from "@/views/checkout/constant";
import {pageConfig} from "@/common/service/page-config";

const getDefaultIpLocation = () => {
  return {
    cn: "",
    countryName: "",
    region: "",
    regionName: "",
    city: "",
    postalCode: "",
    locationId: undefined,
  }
}

const disabledCurrencyFilterTypeMap = {
  categoryCode: 1,
  planCode: 2,
}

// disabled parent categoryCode or planCode with currency list
const transferDisabledCurrencyList = (disableCurrencyList) => {
  return reduce(disableCurrencyList, (res, item) => {
    const codeType = item?.filterType;

    if (codeType === disabledCurrencyFilterTypeMap.categoryCode) {
      res.disableCurrency4PlanCategory[item?.code] = item?.currencyList;
    } else if (codeType === disabledCurrencyFilterTypeMap.planCode) {
      res.disableCurrency4PlanCode[item?.code] = item?.currencyList;
    }

    return res;
  }, {
    disableCurrency4PlanCategory: {},
    disableCurrency4PlanCode: {},
  })
}

export const COMMON_ACTION_TYPES = {
  basicConfig: '/basic/config',
  initPage: '/init/page',
}

const state = {
  ipLocation: getDefaultIpLocation(),
  ttrTaxExemptionEnabled: false,
  enableProMonIncrease: false,
  enableProAnnualIncrease: false,
  enableTranslation: false,
  enableStandaloneCycleLimit: false,
  indiaMandateAmount: '',
  onSessionPaymentEnabled: false,
  disableCurrency4PlanCategory: {},
  enableBizPriceIncrease: false,
}

const getters = {
  ipLocation: (state) => state.ipLocation,
  ttrTaxExemptionEnabled: (state) => state.ttrTaxExemptionEnabled,
  enableProMonIncrease: (state) => state.enableProMonIncrease,
  enableProAnnualIncrease: (state) => state.enableProAnnualIncrease,
  enableTranslation: (state) => state.enableTranslation,
  flowType: (state)=>state.flowType,
  disableCurrency4PlanCategory: (state) => state.disableCurrency4PlanCategory,
  enableStandaloneCycleLimit: (state) => state.enableStandaloneCycleLimit,
  indiaMandateAmount: (state) => state.indiaMandateAmount,
  onSessionPaymentEnabled: (state) => state.onSessionPaymentEnabled,
  enableBizPriceIncrease: (state) => state.enableBizPriceIncrease
}

const mutations = {
  setIpLocation(state, data) {
    state.ipLocation = data;
  },
  setTtrTaxExemptionEnabled(state, data) {
    state.ttrTaxExemptionEnabled = data;
  },
  setEnableProMonIncrease(state, isEnable) {
    state.enableProMonIncrease = !!isEnable;
  },
  setDisableCurrency4PlanCategory(state, data = {}) {
    state.disableCurrency4PlanCategory = data;
  },
  setEnableBizPriceIncrease(state, isEnable) {
    state.enableBizPriceIncrease = !!isEnable;
  }
}

const actions = {
  async [COMMON_ACTION_TYPES.initPage]({dispatch}) {
    try {
      await Promise.all([dispatch(COMMON_ACTION_TYPES.basicConfig), dispatch("getBasicConfig")]);
    } catch (e) {
      console.error(e);
    }
  },
  async [COMMON_ACTION_TYPES.basicConfig]({state, commit}) {
    const {result = getDefaultIpLocation()} = await getBasicConfig$Cache();
    const {
      iplocation,
      disableCurrencyList = [],
      ttrTaxExemptionEnabled = false,
      enableProMonIncrease = false,
      enableProAnnualIncrease = false,
      enableTranslation = false,
      isIndiaCustomerNonINR = false,
      enableCycleLimit = false,
      enableStandaloneCycleLimit = false,
      indiaMandateAmount = '',
      onSessionPaymentEnabled = false,
      leadFormSupportPlanCodes,
      enableBizPriceIncrease = false
    } = result;
    const { disableCurrency4PlanCategory } = transferDisabledCurrencyList(disableCurrencyList);

    commit('setIpLocation', iplocation);
    commit('setTtrTaxExemptionEnabled', ttrTaxExemptionEnabled);
    commit('setDisableCurrency4PlanCategory', disableCurrency4PlanCategory);
    commit('setLeadCreationSupportedPlans', leadFormSupportPlanCodes);

    // update flag
    state.enableProMonIncrease = enableProMonIncrease;
    state.enableProAnnualIncrease = enableProAnnualIncrease;
    state.enableTranslation = enableTranslation;
    state.isIndiaCustomerNonINR = isIndiaCustomerNonINR;
    state.enableCycleLimit = enableCycleLimit;
    state.enableStandaloneCycleLimit = enableStandaloneCycleLimit;
    state.indiaMandateAmount = indiaMandateAmount;
    state.onSessionPaymentEnabled = onSessionPaymentEnabled && ON_SESSION_PAYMENT_SUPPORTED_FLOWS.includes(pageConfig.type);
    state.enableBizPriceIncrease = enableBizPriceIncrease;
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
